export const SHARERESULT_REQUEST = "SHARERESULT_REQUEST";
export const SHARERESULT_RECEIVE = "SHARERESULT_RECEIVE";
export const SHARERESULT_FAILURE = "SHARERESULT_FAILURE";
export const RESET_SHARERESULT = "RESET_SHARERESULT";
